import { motion } from 'framer-motion';
import { PageTransition, FadeIn, StaggerContainer, StaggerItem } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';
import { StaticCard, TrainingReferenceLink } from '../components/BorderCard';
import { CheckCircle2 } from 'lucide-react';

const guidelines = [
  'Garment preparation',
  'Tag hygiene',
  'Layering standards',
  'Button standards',
  'Folding standards',
  'Wall alignment',
  'Hanging standards',
  'Front display rules',
  'Style separation',
  'Final VM discipline checklist'
];

const VMGuidelinesPage = () => {
  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/what" label="Back" />

      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-4">
            Training Module
          </h2>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight text-[#1A1A1A] mb-4">
            VM Guidelines
          </h1>
          <TrainingReferenceLink 
            href="https://www.canva.com/design/DAHBFu_LmNg/Pf1O_-h14waxxXIXHWIq7Q/view?utm_content=DAHBFu_LmNg&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hf732e636f5"
          />
          <p className="text-sm text-[#1A1A1A]/60 mt-4 max-w-xl mx-auto">
            Visual Merchandising standards for maintaining store presentation excellence
          </p>
        </motion.div>

        {/* Guidelines Grid */}
        <FadeIn delay={0.2}>
          <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-center text-[#1A1A1A]/60 mb-8">
            Standards Covered
          </h3>
        </FadeIn>
        
        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
          {guidelines.map((guideline, index) => (
            <StaggerItem key={index}>
              <StaticCard className="p-5">
                <div className="flex items-center gap-4">
                  <div className="flex items-center justify-center w-8 h-8 border border-[rgba(26,26,26,0.1)] text-[#1A1A1A]/60 text-xs font-semibold">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <span className="text-sm text-[#1A1A1A]">{guideline}</span>
                </div>
              </StaticCard>
            </StaggerItem>
          ))}
        </StaggerContainer>

        {/* Key Principles */}
        <FadeIn delay={0.5}>
          <div className="border-t border-[rgba(26,26,26,0.1)] pt-12">
            <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-center text-[#1A1A1A]/60 mb-8">
              Key Principles
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {['Consistency', 'Precision', 'Brand Alignment'].map((principle, index) => (
                <StaticCard key={index} className="p-6 text-center">
                  <CheckCircle2 size={24} className="mx-auto mb-3 text-[#D32F2F]" />
                  <span className="text-sm uppercase tracking-[0.1em] font-medium text-[#1A1A1A]">
                    {principle}
                  </span>
                </StaticCard>
              ))}
            </div>
          </div>
        </FadeIn>
      </div>
    </PageTransition>
  );
};

export default VMGuidelinesPage;
